import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const featuresSectionStyles = {
  wrapper: (): SystemStyleObject<Theme> => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  }),
  card: (): SystemStyleObject<Theme> => ({
    backgroundImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/features/background.png)`,
    backgroundRepeat: "no-repeat",
    aspectRatio: "581 / 500",
    backgroundSize: "contain",
    p: { xs: 3, xl: 5 },
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    minWidth: { xs: "100%", md: "49%", lg: "32%" },
    width: { xs: "100%", md: "49%", lg: "32%" },
  }),
  title: (): SystemStyleObject<Theme> => ({
    mb: 2,
    fontWeight: 600,
  }),
  description: (): SystemStyleObject<Theme> => ({
    mb: 0,
  }),
  detailsButton: (): SystemStyleObject<Theme> => ({
    textTransform: "none",
    alignSelf: "start",
    mt: "auto",
  }),
};

export default featuresSectionStyles;
